import { SceneState } from '../../../components/SceneStatemachinePlugin';
import { HUMALONG_VO } from '../config/config';

export class StateXylophoneSongComplete extends SceneState {
  constructor(scene, { character }) {
    super(scene);
    this.character = character;
  }

  startState() {
    this.character.play('humming_end', true, true);
    this.scene.game.vo.playChain(HUMALONG_VO.complete, {
      onComplete: () => this.emit('state_complete'),
    });
  }
}
